/* eslint-disable complexity */
import { hasSelectedFacets, getSort, getPaginationMax } from "./modules/search";
import {
  isFacetedNavPage,
  getCategoryStatusIsNotFound,
  getCategoryDetails
} from "./modules/category/selectors";

export const shouldRenderPagination = state => {
  const isCategoryStatusIsNotFound = getCategoryStatusIsNotFound(state);
  if (isCategoryStatusIsNotFound) {
    return false;
  }

  const category = getCategoryDetails(state);
  const canonicalUrls =
    category && category.canonicalUrls ? category.canonicalUrls : {};

  const canonicalKey = Object.keys(canonicalUrls);
  const ctaPageCheck = canonicalKey.some(key => {
    const url = canonicalUrls[key];

    return url && url.toLowerCase().includes("/cta/");
  });

  if (ctaPageCheck) {
    return false;
  }

  const countryCode = state.config.country.countryCode;
  if (countryCode === "IT" || countryCode === "SE") {
    return false;
  }

  const baseCondition =
    (isFacetedNavPage(state) || !hasSelectedFacets(state)) && !getSort(state);

  const maxPage = getPaginationMax(state);
  const hasMultiplePages = typeof maxPage === "number" && maxPage > 1;

  return baseCondition || hasMultiplePages;
};
